import React from 'react';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const BOOKED_STATUSES = ['confirmed', 'reserved'];

export const UpcomingEvents = ({ calendarDates }) => {
  const now = new Date();
  const upcoming = calendarDates
    .filter(d => new Date(d.date) >= now && BOOKED_STATUSES.includes(d.status))
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, 5);

  const hasUpcoming = calendarDates.some(d => new Date(d.date) >= now);

  return (
    <Card className="mt-8 border-2 border-[#8B7355]/20">
      <CardHeader>
        <CardTitle className="font-serif text-2xl text-[#8B7355]">Upcoming Events</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {upcoming.map(date => (
            <div key={date.id} className="flex items-center justify-between p-4 bg-[#F5F1E8] rounded-lg">
              <div>
                <p className="font-serif text-[#8B7355] font-semibold">{date.date}</p>
                {date.inquiry && (
                  <p className="text-sm text-[#8B7355]/70">
                    {date.inquiry.name} - {date.inquiry.event_type}
                  </p>
                )}
              </div>
              <Badge className={date.status === 'confirmed' ? 'bg-green-600' : 'bg-yellow-600'}>
                {date.status}
              </Badge>
            </div>
          ))}

          {!hasUpcoming && (
            <p className="text-center text-[#8B7355]/70 py-8">No upcoming events</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
